import { useEffect, type RefObject } from 'react';
import type { AnchorHeight } from '../game/IProjection';
import type { OverlayTarget } from '../game/OverlayProjector';
import { useOffice } from '../features/office/OfficeContext';

/**
 * Verankert ein DOM-Element an einer Welt-Position: der OverlayProjector
 * schreibt pro Frame die Projektion als transform auf das Element. Die
 * Ankerhoehe stammt aus game/overlayAnchors.
 */
export function useOverlayAnchor(
  ref: RefObject<HTMLElement | null>,
  target: OverlayTarget,
  height: AnchorHeight,
): void {
  const { runtime } = useOffice();
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    return runtime.projector.anchor(el, target, height);
    // target bewusst ueber Schluesselwerte verglichen (Objekt-Identitaet wechselt pro Render)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runtime, ref, target.kind, target.kind === 'player' ? target.id : `${target.x}:${target.y}`, height]);
}
